


















































import MobileNavPane from './pane'
import HeaderHeightMixin from 'library/mixins/header-height'

export default

	mixins: [ HeaderHeightMixin ]

	components: {
		MobileNavPane
	}

	data: ->
		activePane: ''

	computed:
		navigationData: -> @$store.state.globals.mobileNavigation
		navigationItems: -> @navigationData?.children || []
		mobileMenuLinks: -> @navigationData?.menuLinks?

		calculatedHeader: ->
			'--calculated-header': @mobileHeaderHeight

	methods:
		topLevelRef: (title) -> title.toLowerCase()
		paneRef: (title) -> "pane-#{title.toLowerCase()}"

		openPane: (title) ->
			@activePane = "pane-#{title.toLowerCase()}"

		# called from parent when the nav closes
		# as well as the child pane's back button
		reset: ->
			@activePane = ''

			# this is caught by the main mobile component
			# so I can re-establish a lock on the main window
			@$emit 'reset'

	watch:

		# Close the nav when the route changes
		$route: ->
			@reset()

